module.exports = __webpack_public_path__ + "static/media/squat.414515aa.jpg";